// utils/auth.js — add this helper
export const getEmailFromToken = () => {
  const token = localStorage.getItem("auth_token");
  if (!token) return "";
  try {
    // JWT is base64url encoded — middle part is the payload
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.sub || payload.email || "";
  } catch {
    return "";
  }
};